// src/pages/Projeto/ProjetoDetailsPage.jsx
import React from 'react';
import ProjetoDetails from '../../components/Projeto/ProjetoDetails';
import { useParams } from 'react-router-dom';

const ProjetoDetailsPage = () => {
    const { id } = useParams();

    return (
        <div className="p-6 space-y-6">
            <h1 className="text-2xl font-bold">Detalhes do Projeto</h1>
            <ProjetoDetails projetoId={id} />
        </div>
    );
};

export default ProjetoDetailsPage;